<template>
  <div>
    <section>
      <div class="user-wrapper">
        <div class="user-profile">
          <el-avatar :size="45" src="/images/default-user.png"></el-avatar>
        </div>
        <div class="user-info">
          <label class="name" v-text="user.username"></label>
          <label class="email" v-text="user.email"></label>
        </div>
      </div>
      <el-menu :router="true">
        <!-- :class="route.submenus.length > 0 ? 'menu-parent' : ''" -->
        <li class="el-menu-item">
          <router-link :to="{ name: 'parts' }">
            <i class="el-icon-cpu"></i> Parts</router-link
          >
        </li>
        <li class="el-menu-item menu-parent">
          <a href="#"> <i class="el-icon-brush"></i> Production</a>
          <ul class="sidebar-submenu">
            <li>
              <router-link :to="{ name: 'repairULD' }">
                ULD In
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'repairULD_Out' }">
                ULD Out
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'repairMasterlist' }">
                Masterlist Details
              </router-link>
            </li>
          </ul>
        </li>
        <li class="el-menu-item menu-parent">
          <a href="#"> <i class="el-icon-s-order"></i> Reports</a>
          <ul class="sidebar-submenu">
            <li>
              <router-link :to="{ name: 'DamageReport' }">
                Damage Report
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'inventoryReport' }">
                Inventory
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'nonmoving' }">
                Non-Moving
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ProductionReport' }">
                Production Report
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'stockinReport' }">
                Stockin Report
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'stockoutReport' }">
                Stockout Report
              </router-link>
            </li>

          </ul>

        </li>
      </el-menu>
    </section>
  </div>
</template>

<script>
export default {
  name: "SupervisorNav",
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  mounted() {
    var nav = document.getElementById("side-nav");
    if (nav)
      document.documentElement.style.setProperty(
        "--side-nav-width",
        `${nav.clientWidth}px`
      );
  }
};
</script>

<style lang="scss" scoped>
#side-nav li.menu-parent {
  &:hover {
    .sidebar-submenu {
      display: block;
    }
  }
  a.router-link-active + .sidebar-submenu {
    display: block;
  }
  .sidebar-submenu {
    display: none;
  }
  .sidebar-submenu {
    margin: 0;
    padding: 0;
    > li {
      display: flex;
      flex-direction: column;
    }
    > li a {
      background-color: darken(#1e282c, 3);
      &.router-link-active {
        background-color: darken(#1e282c, 4);
      }
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>
